import ClipboardJS from 'clipboard/dist/clipboard.min';
import $ from "../jquery_global";

window.Batch = {
  init() {
    let self = this
    var clipboard =new ClipboardJS('.clipboard-btn');
    clipboard.on('success', function(e) {
      self.setTooltip(e.trigger, 'Copied!');
      self.hideTooltip(e.trigger);
    });
    this.handleArchiveBatchOnClick();
    this.handleTraceBulkCSVFileSelector();
    this.handleSelectAllTemplateOnChecked();
  },

  handleSelectAllTemplateOnChecked() {
    $('#select-all-template').on('change', function(e) {
      var $inputs = $('.trace-template input[type=checkbox]');
      if(e.originalEvent === undefined) {
          var allChecked = true;
          $inputs.each(function(){
              allChecked = allChecked && this.checked;
          });
          this.checked = allChecked;
      } else {
          $inputs.prop('checked', this.checked);
      }
    });

    $('.trace-template input[type=checkbox]').on('change', function(){
      $('#select-all-template').trigger('change');
    });
  },

  setTooltip(btn, message) {
    $(btn).tooltip('hide')
      .attr('data-original-title', message)
      .tooltip('show');
  },

  hideTooltip(btn) {
    setTimeout(function() {
      $(btn).tooltip( "dispose" )
    }, 1000);
  },

  handleTraceBulkCSVFileSelector() {
    $('#trace_csv_upload_csv_file').on('change', (e) => {
      var fileName = e.target.files[0].name;
      var allowedExtension = ["csv"];
      var selectedExt = fileName.split('.').pop();
      $('#import_csv_label').html(fileName);
      if ($.inArray(selectedExt, allowedExtension) == -1) {
        $('#new_trace_csv_upload button[type="submit"]').prop('disabled', true);
      } else {
        $('#new_trace_csv_upload button[type="submit"]').prop('disabled', false);
      }
    });
  },

  handleArchiveBatchOnClick() {
    $(document).on('click', '.toggle-archive-batch', (event) => {
      this.handleArchiveBatch(event);
    })
  },

  handleArchiveBatch(e) {
    const isArchived = JSON.parse(e.target.value)
    let params = {
      batch: {
        is_archived: !isArchived
      }
    }

    $.ajax({
      url: `/admin/batches/${e.target.dataset.batchUuid}/mark_archived`,
      type: 'PATCH',
      data: params,
      dataType: "json",
      success: (data) => {
        if (data) {
          if (data.error) {
            e.target.checked = isArchived
            e.target.value = isArchived
            alert(data.error)
          }
          e.target.checked = !isArchived
          e.target.value = !isArchived
          let successMessage = isArchived ? "Trace was unarchived." : "Trace was archived."
          alert(successMessage)
        }
      },
      failure: (error) => {
        alert(error)
      }
    });
  },

  initFormValidation(selector) {
    $.validator.addMethod("productionStartDateNotEmptyIfEndSelected", function(value) {
      var productionStartDate = $('[name="batch[production_start_date]"]').val();
      var productionEndDate = $('[name="batch[production_end_date]"]').val();

      if (productionStartDate == "") {
        if (productionEndDate == "") {
          return true;
        } else {
          return false;
        }
      }

      return true;
    });

    $.validator.addMethod("productionEndDateNotEmptyIfStartSelected", function(value) {
      var productionStartDate = $('[name="batch[production_start_date]"]').val();
      var productionEndDate = $('[name="batch[production_end_date]"]').val();

      if (productionEndDate == "") {
        if (productionStartDate == "") {
          return true;
        } else {
          return false;
        }
      }

      return true;
    });

    $(selector).validate({
      ignore: [],
      rules: {
        "batch[production_start_date]": {
          productionStartDateNotEmptyIfEndSelected: true
        },
        "batch[production_end_date]": {
          productionEndDateNotEmptyIfStartSelected: true
        },
      },
      messages:{
        "batch[production_start_date]": {
          productionStartDateNotEmptyIfEndSelected: "Start date can't be blank when end date is selected"
        },
        "batch[production_end_date]": {
          productionEndDateNotEmptyIfStartSelected: "End date can't be blank when start date is selected"
        }
      },
      errorPlacement: function(error, element) {
        if (element[0].id == "understand") {
          error.insertAfter(element.parent().parent());
        } else {
          error.insertAfter(element.next());
          element.next().focus();
        }
      },
      errorClass: "is-invalid text-danger",
      errorsWrapper: "<span class='form-text text-danger'></span>",
      errorTemplate: "<span></span>",
      trigger: "change"
    });
  },
  handleHeroImage() {
    $(document).off('click', '.delete-hero-image-btn').on('click', '.delete-hero-image-btn', (event) => {
      const $img = $(event.currentTarget).siblings('img')

      $.ajax({
        url: `/admin/batches/${$img.data('batchId')}/hero_image`,
        type: 'DELETE',
        data: {
          hero_image_id: $img.data('attachmentId')
        },
        dataType: "json",
        success: (data) => {
          $img.parents('.col-auto').remove()
        },
        failure: (error) => {
          alert(error)
        }
      })
    })

    $(document).off('click', 'button.upload-hero-image-btn').on('click', 'button.upload-hero-image-btn', function(e) {
      e.preventDefault();
      const btn = $(e.currentTarget)
      btn.attr('disabled','disabled')
      if (document.querySelector('#heroImageUpload').files.length < 1) {
        alert('Select atleast 1 image to upload')
        return;
      }
      const data = new FormData()
      for (const file of document.querySelector('#heroImageUpload').files) {
        console.log(file)
        data.append('hero_images[]', file)
      }
      $.post({
        url: btn.data('url'),
        type: 'POST',
        data,
        dataType: 'script',
        processData: false,
        contentType: false,
      }).done((_res) => {
        $('.trace-hero-image-file-label').html('Hero images');
      }).fail(function() {
        btn.removeAttr('disabled')
      })
    })
  },
  handleCreateContentBlock() {
    $('form#new_content_block').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const form = $(this)
      const formData = new FormData(this);

      $.ajax({
        url: form.attr('action'),
        type: 'POST',
        data: formData,
        dataType: 'script',
        processData: false,
        contentType: false,
      })
    })
    $(document).on('click', 'form#new_content_block .delete-btn', function(e) {
      e.preventDefault();

      const button = $(this)
      $.ajax({
        url: button.data('url'),
        type: 'DELETE',
        dataType: 'script',
      })
    })
  },
  handleCreateCustomContentBlock() {
    $('form#new_custom_content_block').on('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const form = $(this)
      const formData = new FormData(this);

      $.ajax({
        url: form.attr('action'),
        type: 'POST',
        data: formData,
        dataType: 'script',
        processData: false,
        contentType: false,
      })
    })
    $(document).on('click', 'form#new_custom_content_block .delete-btn', function(e) {
      e.preventDefault();

      const button = $(this)
      $.ajax({
        url: button.data('url'),
        type: 'DELETE',
        dataType: 'script',
      })
    })
  }
};
